import common from './common/fr.i18n.json'
export default { common }
